export enum CalendarProvider {
  GOOGLE = 'google',
  OUTLOOK = 'outlook'
}
